import { getButton, getDiv } from '~/js/utils/selectors';
import { addClass, removeClass } from '~/js/utils/class-management';

function animateMobileMenu() {
  const body = document.querySelector('body') as HTMLBodyElement;
  const toggleMobileMenuButton = getButton('.toggle-mobile-menu');
  const mobileMenuWrap = getDiv('#mobile-menu-wrapper');
  const mobileMenuOverlay = getDiv('.mobile-menu-overlay');
  toggleMobileMenuButton.addEventListener('click', () => {
    addClass(body, 'no-scroll');
    addClass(mobileMenuWrap, 'opened');
    addClass(mobileMenuOverlay, 'opened');
  });

  mobileMenuOverlay.addEventListener('click', () => {
    removeClass(body, 'no-scroll');
    removeClass(mobileMenuWrap, 'opened');
    removeClass(mobileMenuOverlay, 'opened');
  });
}

export default animateMobileMenu;
